const Diets = () => import("./views/Diets.vue");
const DietEdit = () => import("./views/DietEdit.vue");

const route = "/diets";

export default [
  {
    path: route,
    name: "diets.list",
    component: Diets,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "diets.create",
    component: DietEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:dietId/edit`,
    name: "diets.edit",
    component: DietEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
